import { useFetch } from "@andorhealth/clientuireact.designsystem";
import { getBaseUrl } from "@/lib/api-base";

export interface TenantResponse {
  view: {
    LOGO_LIGHT: string;
    LOGO_DARK: string;
    PHONE_NUMBER: string;
    CORPORATE_URL: string;
    VIDEO_URL: string;
  };
}

export type TenantView = TenantResponse["view"];

const BRANDING_PATH = "/api/taxonomy/branding";

export const useGetTenantConfig = (tenantKey: string | undefined) => {
  const baseUrl = getBaseUrl().replace(/\/$/, "");
  const url = tenantKey
    ? `${baseUrl}${BRANDING_PATH}?tenant=${encodeURIComponent(tenantKey)}&name=TENANT_GLOBALS`
    : "";

  const result = useFetch<TenantResponse>(url, {
    autoRun: Boolean(tenantKey),
  });

  const view: TenantView | undefined = result.data
    ? result.data.view
    : undefined;

  return {
    ...result,
    view,
  };
};
